import React from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import css from "./style.module.css";
import { useOktaConfig } from "../../Context/CredentialsContext";
import { testSalesforceConnection } from "./onboardingApi";

export default function VerifyScreen({ companyId, onStartOver }) {
  const { loginToken } = useOktaConfig();
  const navigate = useNavigate();

  const { data, isFetching, isError, error, refetch } = useQuery({
    queryKey: ["onboardSfTest", companyId],
    queryFn: () => testSalesforceConnection({ loginToken, companyId }),
    enabled: !!companyId && !!loginToken,
    retry: false,
  });

  const ok = data?.ok === true;
  const errMessage = data?.error || error?.message;

  return (
    <>
      <h5 className="mb-1">Verify Salesforce connection</h5>
      <p className="text-muted small mb-4">
        We just stored the customer's Salesforce credentials. Let's confirm they work.
      </p>

      {isFetching && (
        <div className="text-center my-4">
          <div className="spinner-border text-secondary" role="status" />
          <p className="mt-2 mb-0 text-muted">Testing connection…</p>
        </div>
      )}

      {!isFetching && ok && (
        <div className={`${css.verifyCard} ${css.verifyOk}`}>
          <div className={css.verifyIcon}>✓</div>
          <h5 className="mb-1">Salesforce connection healthy</h5>
          {data?.orgId && (
            <p className="mb-0 small">Connected org ID: <code>{data.orgId}</code></p>
          )}
        </div>
      )}

      {!isFetching && !ok && (isError || data) && (
        <div className={`${css.verifyCard} ${css.verifyErr}`}>
          <div className={css.verifyIcon}>!</div>
          <h5 className="mb-1">Could not connect to Salesforce</h5>
          <p className="mb-0 small">
            {errMessage || "The stored credentials did not authenticate."}
          </p>
        </div>
      )}

      <div className="d-flex justify-content-between flex-wrap gap-2 mt-4">
        <button
          type="button"
          className="btn btn-outline-secondary"
          onClick={onStartOver}
        >
          Onboard another
        </button>
        <div className="d-flex gap-2">
          <button
            type="button"
            className="btn btn-outline-primary"
            onClick={() => refetch()}
            disabled={isFetching}
          >
            Retry test
          </button>
          <button
            type="button"
            className={`btn ${css.btnPrimary}`}
            onClick={() => navigate("/companies")}
          >
            Go to companies
          </button>
        </div>
      </div>
    </>
  );
}
